// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__gvZ6z","slider":"style_slider__Gdzzh","round":"style_round__FtH-v"};